import 'moment/locale/ja'

import ArchiveIcon from '@mui/icons-material/Archive'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import moment from 'moment'

import { numberWithCammas } from 'utils'
import { NO_DEADLINE_DATE } from 'utils/constant'

export const Mode = Object.freeze({
  ACCOUNT_STOCKLIST: 0,
  ADMIN_STOCKLIST: 1,
  ADMIN_DASHBOARD: 2,
})

export default function StockListItem({
  data,
  onClick,
  onClickSecondary,
  mode = Mode.ACCOUNT_STOCKLIST,
}) {
  const expired = data.expire < new Date()

  const Expire = () => {
    if (moment(data.expire).isSame(moment(NO_DEADLINE_DATE), 'day')) {
      return '期限なし'
    } else {
      return (
        <Typography
          component="span"
          sx={{ fontSize: 12, color: expired ? 'secondary.main' : 'text.secondary' }}
        >
          {moment(data.expire).format('YYYY/MM/DD')}
        </Typography>
      )
    }
  }

  const TextSecondary = () => {
    switch (mode) {
      case Mode.ACCOUNT_STOCKLIST:
        let location = data.location.name
        if (data.storage) {
          location += ` ${data.storage}`
        }
        return (
          <>
            {location}・{data.amount}個・
            <Expire />
          </>
        )
      case Mode.ADMIN_STOCKLIST:
        return (
          <>
            {data.account.name} {data.location.name}・{data.amount}個・
            <Expire />
          </>
        )
      case Mode.ADMIN_DASHBOARD:
        return (
          <>
            {data.location.name}・{data.amount}個・{numberWithCammas(data.price * data.amount)} 円
          </>
        )
      default:
        return null
    }
  }

  const Image = ({ src }) => {
    return src ? (
      <img
        src={src}
        alt={src}
        style={{
          width: 120,
          height: 'auto',
          objectFit: 'cover',
        }}
      />
    ) : (
      <div
        style={{
          width: 120,
          height: 'auto',
          background: '#e6e6e6',
          color: '#757575',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
        }}
      >
        No Image
      </div>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
        alignItems: 'center',
        background: data.deleted ? '#f6f6f6' : '#fff',
      }}
    >
      <ButtonBase onClick={onClick} style={{ flex: 1, display: 'block' }}>
        <div style={{ display: 'flex' }}>
          <Image src={data.image} />
          <Box sx={{ flex: 1, p: 2, textAlign: 'left' }}>
            <Typography align="left" variant="body1">
              {data.name}
            </Typography>
            <Typography alig="left" sx={{ mt: 1 }} variant="caption" component="p">
              <TextSecondary />
            </Typography>
          </Box>
        </div>
      </ButtonBase>
      {mode === Mode.ACCOUNT_STOCKLIST && expired && !data.deleted && (
        <Tooltip title="削除">
          <IconButton
            color="primary"
            sx={{ mr: 1, height: 48 }}
            onClick={() => onClickSecondary(data)}
          >
            <ArchiveIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}
